import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'

const SubmitButton = ({ disabled, loading, onClick }) => {
  return (
    <Tooltip
      title={'Descreva o chamado para continuar'} placement="bottom" arrow
      disableHoverListener={!disabled || loading}
    >
      <span>
        <Button variant='contained' color='primary' onClick={onClick}
          sx={{ width: '120px', height: '40px', padding: '8px 22px' }}
          disabled={disabled || loading} data-testid="submit-button"
        >
          {loading ? <CircularProgress size={16} color="inherit" /> : "Continuar"}
        </Button>
      </span>
    </Tooltip>
  )
}

export default SubmitButton
